<mat-form-field floatLabel="auto" appearance="outline" class="w-100 bdg-date-field">
  <mat-label>{{ label }}</mat-label>
  <mat-date-range-input [rangePicker]="picker" [dateFilter]="filter" (click)="onPickerClicked()">
    <input
      #nativeElement
      matStartDate
      [placeholder]="placeholderStart"
      autocomplete="off"
      [formControl]="startDateControl"
      (dateInput)="onStartDateInput($event)"
      readonly="true"
    />
    <input
      #nativeElement
      matEndDate
      [placeholder]="placeholderEnd"
      autocomplete="off"
      (dateInput)="onEndDateInput($event)"
      [formControl]="endDateControl"
      readonly="true"
    />
  </mat-date-range-input>
  <mat-datepicker-toggle [class.mat-error]="error()" matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-date-range-picker #picker></mat-date-range-picker>
  <mat-hint>{{ hint }}</mat-hint>
  <mat-error *ngIf="error()">{{ error() }}</mat-error>
</mat-form-field>
